export default __webpack_public_path__ + "static/media/player.281d6a57.jpg";